<template>
    <tr>
        <td v-for="cell in cells" :key="cell.id">
            <component
                :is="getCellComponent(cell)"
                :cell="cell"
                :column="getColumn(cell)"
            />
        </td>
    </tr>
</template>

<script>
import TextCell from "./TextCell.vue";
import Filecell from "./FileCell.vue";
import DropdownCell from "./DropdownCell.vue";
import CheckCell from "./CheckCell.vue";
import DateCell from "./DateCell.vue";

export default {
    name: "table-row",
    props: {
        row: {
            type: Object,
            required: true,
        },
        columns: {
            type: Array,
            required: true,
        },
    },
    computed: {
        cells() {
            return this.row.cells;
        },
    },
    methods: {
        getCellComponent(cell) {
            switch (cell.discriminator) {
                case "text":
                    return TextCell;
                case "file":
                    return Filecell;
                case "dropdown":
                    return DropdownCell;
                case "check":
                    return CheckCell;
                case "datetime":
                    return DateCell;
            }
            return null;
        },
        getColumn(cell) {
            return this.columns.find((c) => c.id === cell.columnId);
        },
    },
};
</script>